import React, { memo } from 'react';
import { GlobalStyles } from 'tss-react';
import { useStyles } from 'tss-react/mui';
export const ReactTabsStylesOverride = memo(() => {
    const { theme } = useStyles();
    return (React.createElement(GlobalStyles, { styles: {
            div: {
                '.react-tabs__tab': {
                    ...theme.typography.labelRegular,
                    lineHeight: 'initial',
                    color: theme.palette.iisightDefaultText,
                },
                '.react-tabs__tab--selected': {
                    backgroundColor: theme.palette.iisightBrand,
                    borderColor: theme.palette.iisightBrand,
                    color: theme.palette.iisightWhiteText,
                },
                '.react-tabs__tab-list': {
                    borderWidth: 2,
                    marginBottom: theme.spacing(4),
                    border: "none",
                    position: 'relative',
                },
            },
        } }));
});
